const useIsNI2 = (currentContract) => {
  const isSWProvider = currentContract?.insuranceProvider === 'SAFETYWING';

  return { isSWProvider };
};

export default useIsNI2;
